module.exports = __webpack_public_path__ + "static/media/front.6740f845.jpg";